export default __webpack_public_path__ + "static/media/Category_CleaningSupplies_135x195.ff975f38.jpg";